module.exports = __webpack_public_path__ + "img/yhrs_logo.ae50aef8.png";